import { useState, useEffect, useCallback } from "react";
import { searchListings } from "../../service/listing/listingService";

const PAGE_SIZE = 10;

export const useSearch = (text, category_id, parent_id) => {
  const [listings, setListings] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchListings = useCallback(async (pageNum, searchText) => {
    setLoading(true);
    setError(null);
    try {
      const newItems = await searchListings(searchText, category_id, parent_id, pageNum, PAGE_SIZE);
      if (pageNum === 1) {
        setListings(newItems);
      } else {
        setListings((prev) => [...prev, ...newItems]);
      }
      setPage(pageNum + 1);
      setHasMore(newItems.length === PAGE_SIZE);
    } catch (e) {
      setError("Không thể tải dữ liệu.");
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  }, [category_id, parent_id]);

  useEffect(() => {
    if (text) {
        fetchListings(1, text);
    } else {
        setListings([]);
    }
  }, [text, fetchListings]);

  const loadMore = useCallback(() => {
    if (loading || !hasMore || !text) return;
    fetchListings(page, text);
  }, [loading, hasMore, page, text, fetchListings]);

  return {
    searchedListings: listings,
    searchLoading: loading,
    searchError: error,
    searchHasMore: hasMore,
    loadMoreSearchResults: loadMore,
  };
};
